"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutWidgets = exports.layoutWidgetsWithPaths = exports.walkLayout = exports.isDashboardLayoutEmpty = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var layout_1 = require("./layout");
var widget_1 = require("./widget");
/**
 * Has dashboard layout only empty sections and widgets?
 * @alpha
 */
exports.isDashboardLayoutEmpty = function (layout) {
    return layout.sections.every(function (section) { return section.items.length === 0; });
};
/**
 * Walk dashboard layout
 * This is useful to collect widgets from the layout or perform transforms on the layout
 *
 * @alpha
 * @param layout - dashboard layout
 * @param callbacks - walk callbacks
 * @returns void
 */
function walkLayout(layout, _a, path) {
    var _b = _a.sectionCallback, sectionCallback = _b === void 0 ? noop_1.default : _b, _c = _a.itemCallback, itemCallback = _c === void 0 ? noop_1.default : _c, _d = _a.widgetCallback, widgetCallback = _d === void 0 ? noop_1.default : _d;
    if (path === void 0) { path = ["sections"]; }
    layout.sections.forEach(function (section, sectionIndex) {
        var sectionPath = tslib_1.__spreadArrays(path, [sectionIndex]);
        sectionCallback(section, sectionPath);
        section.items.forEach(function (item, widgetIndex) {
            var itemPath = tslib_1.__spreadArrays(sectionPath, ["items", widgetIndex]);
            itemCallback(item, itemPath);
            if (widget_1.isWidget(item.widget) || widget_1.isWidgetDefinition(item.widget)) {
                var widgetPath = tslib_1.__spreadArrays(itemPath, ["widget"]);
                widgetCallback(item.widget, widgetPath);
            }
            else if (layout_1.isDashboardLayout(item.widget)) {
                // is another layout
                walkLayout(item.widget, {
                    sectionCallback: sectionCallback,
                    itemCallback: itemCallback,
                    widgetCallback: widgetCallback,
                }, tslib_1.__spreadArrays(itemPath, ["widget", "sections"]));
            }
        });
    });
}
exports.walkLayout = walkLayout;
/**
 * Get all dashboard widgets
 * (layout does not only specify rendering, but also all used widgets)
 *
 * @alpha
 * @param layout - dashboard layout
 * @param collectedWidgets - bag for collecting widgets recursively from the layout
 * @returns - widgets with layout paths
 */
function layoutWidgetsWithPaths(layout) {
    var collectedWidgets = [];
    walkLayout(layout, {
        widgetCallback: function (widget, path) {
            return collectedWidgets.push({
                widget: widget,
                path: path,
            });
        },
    });
    return collectedWidgets;
}
exports.layoutWidgetsWithPaths = layoutWidgetsWithPaths;
/**
 * Get all dashboard widgets
 * (layout does not only specify rendering, but also all used widgets)
 *
 * @alpha
 * @param layout - dashboard layout
 * @returns - widgets
 */
function layoutWidgets(layout) {
    var collectedWidgets = [];
    walkLayout(layout, {
        widgetCallback: function (widget) { return collectedWidgets.push(widget); },
    });
    return collectedWidgets;
}
exports.layoutWidgets = layoutWidgets;
//# sourceMappingURL=utils.js.map